module.exports = __webpack_public_path__ + "img/poland.1fc22541.svg";